import { apiBaseSlices } from "./baseAPI";

export const mlmAccountsSlices = apiBaseSlices.injectEndpoints({
    endpoints: (builder) => ({
        getMlmAccounts: builder.mutation({
            query: ({ token, currentPage }) => ({
                url: `mlm-accounts?page=${currentPage}`,
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        getMlmAccount: builder.mutation({
            query: ({ mlmAccountId, token }) => ({
                url: `mlm-accounts/${mlmAccountId}`,
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        createMlmAccount: builder.mutation({
            query: ({ payload, token }) => ({
                url: `mlm-accounts`,
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: payload,
            }),
        }),

        updateMlmAccount: builder.mutation({
            query: ({ payload, mlmAccountId, token }) => ({
                url: `mlm-accounts/${mlmAccountId}`,
                method: "PUT",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: payload,
            }),
        }),

        deleteMlmAccount: builder.mutation({
            query: ({ mlmAccountId, token }) => ({
                url: `mlm-accounts/${mlmAccountId}`,
                method: "DELETE",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        getAllMlmAccounts: builder.mutation({
            query: ({ token }) => ({
                url: `mlm-accounts?all=1`,
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),
    }),
});

export const {
    useGetMlmAccountsMutation,
    useGetMlmAccountMutation,
    useCreateMlmAccountMutation,
    useUpdateMlmAccountMutation,
    useDeleteMlmAccountMutation,
    useGetAllMlmAccountsMutation,
} = mlmAccountsSlices;
